import React, { cloneElement } from 'react';
import {
    List, Filter, Datagrid, TextInput, TextField, ReferenceField, usePermissions, DeleteButton, useRefresh, 
    useListContext, sanitizeListRestProps, TopToolbar, ExportButton, SelectInput, ReferenceInput, AutocompleteInput
} from 'react-admin';
import ISConfig from '../config';
import CustomDateField from '../components/CustomDateField';

const ActionButtons = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props;
    const {
        resource,
        displayedFilters,
        filterValues,
        showFilter,
    } = useListContext();

    return (
        <TopToolbar className="mb-3" {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            <ExportButton />
        </TopToolbar>
    );
}

const SystemFilter = (props) => {
    var SystemStatusSelectChoices = [];
    if (ISConfig.statuses != undefined || ISConfig.statuses != null) { ISConfig.statuses.system.forEach(element => { SystemStatusSelectChoices.push({ id: element, name: element }) }); }
    var SystemTypeSelectChoices = [];
    for (const key in ISConfig.system_types) { SystemTypeSelectChoices.push({ id: ISConfig.system_types[key].label, name: ISConfig.system_types[key].label }) }

    return (
        <Filter {...props}>
            <TextInput className="pt-1" label={<h6 className="px-2 small rounded" style={{ backgroundColor: 'rgb(250, 250, 250)' }}>Name</h6>} source="name" fullWidth variant="outlined" alwaysOn />
            <TextInput className="pt-1" label={<h6 className="px-2 small rounded" style={{ backgroundColor: 'rgb(250, 250, 250)' }}>Code</h6>} source="code" fullWidth variant="outlined" />
            <SelectInput className="pt-1" label={<h6 className="px-2 small rounded" style={{ backgroundColor: 'rgb(250, 250, 250)' }}>Status</h6>} source="status" choices={SystemStatusSelectChoices} fullWidth variant="outlined" />
            <SelectInput className="pt-1" label={<h6 className="px-2 small rounded" style={{ backgroundColor: 'rgb(250, 250, 250)' }}>Type</h6>} source="type" choices={SystemTypeSelectChoices} fullWidth variant="outlined" />
            <ReferenceInput source="location_id" label={<h6 className="px-2 small rounded" style={{ backgroundColor: 'rgb(250, 250, 250)' }}>Location</h6>} resource="locations" reference="locations" filterToQuery={searchText => ({ name: searchText })} fullWidth variant="outlined">
                <AutocompleteInput optionText="name" fullWidth variant="outlined" />
            </ReferenceInput>
        </Filter>
    )
};

const SystemList = props => {
    const toRedirect = useRefresh();
    const p = usePermissions();
    const isAdmin = p.loaded && p.permissions && 'user' in p.permissions && 'admin' in p.permissions && p.permissions.admin;
    const systemDeleteButton = isAdmin ? (<DeleteButton redirect={toRedirect} />) : '';

    return (
        <>
            <h3 className="text-danger px-3 px-md-0 pt-3 pt-md-0" style={{ fontFamily: 'Arial, sans-serif' }}>Systems</h3>
            <List {...props} title=" " filters={<SystemFilter />} bulkActionButtons={false} actions={<ActionButtons />}>
                <Datagrid rowClick="show" className="table table-sm table-hover table-borderless">
                    <ReferenceField label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Location </h6>} source="location_id" resource="locations" reference="locations" link="show" >
                        <TextField className="px-3 text-capitalize" source="name" />
                    </ReferenceField>
                    <TextField source="name" className="px-3 text-capitalize" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Name</h6>} />
                    <TextField source="type" className="px-3 text-capitalize" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Type </h6>} />
                    <TextField source="status" className="px-3 text-capitalize" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Status </h6>} />
                    <TextField source="code" className="px-3" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Code</h6>} />
                    <CustomDateField source="last_inspection" label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Last Inspection </h6>} />
                    <CustomDateField source="next_deadline" label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Next Deadline </h6>} />
                    {systemDeleteButton}
                </Datagrid>
            </List>
        </>
    )
};

export default SystemList;
